import React, { useContext } from 'react'
import { TemplateContext } from '../../context/template'
import '../../components/template/template.scss'
import { AppContext } from '../../context/app'
import { ComponentConfig } from '../../utils/componentConfig'

const TemplateHome = () => {
  const { componentData } = useContext(TemplateContext)
  const { componentCustomForms } = useContext(AppContext)

  const getComponent = (key, data) => {
    if (!key) return
    let componentProps = {
      componentData: data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
      onSwap: () => {},
      onDelete: () => {},
      onCopy: () => {},
      onAdd: () => {},
    }
    if (key === 'customForm') {
      const CustomForm = ComponentConfig[key]
      return <CustomForm {...componentProps} formData={componentCustomForms} />
    }

    if (key === 'artistMaxPlayer') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} />
    }

    if (key === 'artistMaxWithoutText') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} withoutText={true} />
    }

    // Default case
    const Component = ComponentConfig[key]
    return Component ? <Component {...componentProps} /> : null
  }

  return (
    <div>
      {componentData.map((info, index) => getComponent(info?.data?.component_key, info?.data))}
    </div>
  )
}

export default TemplateHome
